<template>
    <div :class="['product-container', currentStyle]" :style="cssVars">
        <template v-if="value.data && value.data.length > 0">
            <div class="product-content">
                <template v-for="(item, index) in value.data">
                    <div class="product-item" v-if="item.display" :key="index">
                        <template v-if="item.key === 'productPic'">
                            <div class="item-image">
                                <img src="../../assets/images/defaultProduct.png" />
                            </div>
                        </template>
                        <template v-else>
                            <div class="item-label">{{ item.name }}</div>
                            <div class="item-value">{{ item.key }}</div>
                        </template>
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <NullView tip="[产品详情]" :height="120" />
        </template>
    </div>
</template>

<script>
import NullView from "./NullView";

export default {
    name: 'ProductView',
    components: {
        NullView
    },
    props: {
        currentStyle: {
            type: String,
            default: () => ''
        },
        value: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        cssVars() {
            return {
                '--title-font-family': this.value.titleFont.fontFamily,
                '--title-font-size': this.value.titleFont.fontSize,
                '--title-font-weight': this.value.titleFont.fontWeight,
                '--title-color': this.value.titleFont.color,
                '--title-line-height': this.value.titleFont.lineHeight,
                '--value-font-family': this.value.textFont.fontFamily,
                '--value-font-size': this.value.textFont.fontSize,
                '--value-font-weight': this.value.textFont.fontWeight,
                '--value-color': this.value.textFont.color,
                '--value-line-height': this.value.textFont.lineHeight,
                '--image-width': this.value.imageWidth + '%',
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.product-container {
    width: 100%;
    box-sizing: border-box;
    padding: 0 var(--padding-x, 0);

    .product-content {
        width: 100%;
    }

    .product-item {
        display: flex;
        align-items: center;
        gap: 20px;
        padding: 10px 0;

        .item-label {
            font-family: var(--title-font-family);
            font-size: var(--title-font-size);
            font-weight: var(--title-font-weight);
            color: var(--title-color);
            line-height: var(--title-line-height);
            flex-shrink: 0;
        }

        .item-value {
            flex: 1;
            font-family: var(--value-font-family);
            font-size: var(--value-font-size);
            font-weight: var(--value-font-weight);
            color: var(--value-color);
            line-height: var(--value-line-height);
            overflow: hidden;
        }

        .item-image {
            flex: 1;
            overflow: hidden;
            text-align: center;

            img {
                width: var(--image-width);
                object-fit: contain;
            }

            .placeholder {
                color: #c0c4cc;
            }
        }
    }

    // style1：一行一个，标题+内容，左侧标题固定宽度，右侧内容靠左
    &.style1 {
        .product-item {
            .item-label {
                width: 100px;
            }

            .item-value {
                text-align: left;
            }
        }
    }

    // style2：一行一个，标题+内容，左侧标题固定宽度，右侧内容靠右
    &.style2 {
        .product-item {
            .item-label {
                width: 100px;
            }

            .item-value {
                text-align: right;
            }
        }
    }
}
</style>
